import React from "react";
import { registerExtension } from "@core/components/PipelineComponents/ExtensionProvider";
import { Popover, PopoverContent, PopoverTrigger } from "@core/components/ui/popover";
import { Button } from "@core/components/ui/button";
import { ChevronDown } from "lucide-react";
import { CategoriesMenu } from "@ecom/CategoriesMenu";
import { ClientOnly } from "@core/components/client-only";

type ProductTabProps = {
  labelClassName?: string;
}

const ProductTab: React.FC<ProductTabProps> = ({ labelClassName }) => {
  const [open, setOpen] = React.useState(false);
  return (
    <ClientOnly>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button variant="ghost" type="button" aria-expanded={open} className={`flex items-center hover:bg-surface-100 hover:text-black data-[state=active]:text-primary-500 data-[state=active]:font-medium data-[state=active]:shadow-none ${labelClassName || ""}`}>
            Products
            <ChevronDown className="h-4 w-4 shrink-0 opacity-50 ml-1" />
          </Button>
        </PopoverTrigger>
        <PopoverContent align="start" className="w-[95vw] md:w-[90vw] xl:w-[1200px] bg-white shadow-lg p-4 z-[999]">
          <CategoriesMenu extraOnClick={() => setOpen(false)} />
        </PopoverContent>
      </Popover>
    </ClientOnly>
  );
}

registerExtension("HomepageTabs.before", ProductTab, "ProductTab");
